"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, /**
 * Primary UI component for user interaction
 */ "default", {
    enumerable: true,
    get: function() {
        return LoungeImageTitle;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
var _core = require("@mantine/core");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n  background: #fff;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var ContentWrapper = _styled.default.div(_templateObject());
function LoungeImageTitle(param) {
    var title = param.title, image = param.image, location = param.location, price = param.price;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(ContentWrapper, {
        children: /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
            direction: "row",
            gap: 24,
            children: [
                image && /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Image, {
                    width: 120,
                    height: 80,
                    src: image,
                    alt: title,
                    radius: "sm"
                }),
                /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Flex, {
                    gap: "md",
                    justify: "center",
                    align: "center",
                    direction: "row",
                    wrap: "wrap",
                    style: {
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Flex, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, _jsxruntime.jsx)("h2", {
                                style: {
                                    fontSize: "12px",
                                    padding: "0",
                                    margin: "0"
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0, _jsxruntime.jsx)("strong", {
                                children: location
                            }),
                            /*#__PURE__*/ (0, _jsxruntime.jsx)("strong", {
                                children: price
                            })
                        ]
                    })
                })
            ]
        })
    });
}
